export class Community {
  constructor () {
    this.id = ''
    this.name = ''
    this.logo = ''
    this.deferredDepositDelayHours = 24
    this.patronTagPairingEnabled = false
    this.maxPatronTagPairings = 1
  }
}
